import type { DialogTitleProps } from '@radix-ui/react-dialog';
import { Title } from '@radix-ui/react-dialog';

export function DrawerTitle(delegatedProps: DialogTitleProps) {
  return <Title className="text-headline-md" {...delegatedProps} />;
}
DrawerTitle.displayName = 'DrawerTitle';
